<div class="container" id="mainContainer">
  <div style="display: flex; flex-direction: column; justify-content: center; width: 100%;">
    <header id="header">
      <img [src]="headerLogo" id="headerImg">
    </header>
    <main style="display: flex; flex-direction: column; justify-content: space-evenly;">
      <router-outlet></router-outlet>
    </main>
    <footer id="footer">
      <img [src]="footerLogo" id="footerImg">
    </footer>
  </div>
</div>
